import classNames from 'classnames';
import React from 'react';
import { NavLink } from 'react-router-dom';
import pageHeaderStyles from './page-header.module.css';
import headersStyles from '../headers.module.css';
import { useMatchScreenWidth } from '../../../../library/hooks/useMatchScreenWidth';
import { HelpIcon } from '../../../../design';
import { IconButton } from '../../../buttons';
function MobileBreadcrumb(_a) {
    var previousBreadcrumb = _a.previousBreadcrumb, currentBreadcrumb = _a.currentBreadcrumb;
    if (!!previousBreadcrumb) {
        return React.createElement(NavLink, { to: previousBreadcrumb.url }, previousBreadcrumb.name);
    }
    if (!!currentBreadcrumb) {
        return React.createElement(NavLink, { to: currentBreadcrumb.url }, currentBreadcrumb.name);
    }
    return React.createElement("span", null, "\u00A0");
}
export function PageHeader(_a) {
    var _b;
    var title = _a.title, subtitle = _a.subtitle, breadcrumbs = _a.breadcrumbs, type = _a.type, children = _a.children, hideContentOnMobile = _a.hideContentOnMobile, forceDark = _a.forceDark, divider = _a.divider, 
    // explainer,
    onClickHelpIcon = _a.onClickHelp;
    if (process.env.NODE_ENV !== 'production') {
        if (!children && !!type) {
            throw new Error('<PageHeader>: When adding `type` to this Component `children` must be specified.');
        }
    }
    var _c = React.useState(false), open = _c[0], setOpen = _c[1];
    var isMobile = useMatchScreenWidth('mobile');
    var previousBreadcrumb = !!breadcrumbs ? breadcrumbs[breadcrumbs.length - 2] : undefined;
    var currentBreadcrumb = !!breadcrumbs ? breadcrumbs[breadcrumbs.length - 1] : undefined;
    return (React.createElement(React.Fragment, null,
        React.createElement("header", { className: classNames("KPLR_PageHeader", pageHeaderStyles.container, pageHeaderStyles[type], (_b = {},
                _b[pageHeaderStyles.forceDark] = forceDark,
                _b[headersStyles.divider] = divider,
                _b)) },
            !!(breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.length) && (React.createElement("div", { className: pageHeaderStyles.breadcrumbs }, isMobile ? (React.createElement("ol", { className: pageHeaderStyles.breadcrumbsList },
                React.createElement("li", { className: classNames(pageHeaderStyles.breadcrumbsListItemMobile, pageHeaderStyles.breadcrumbsListItem) },
                    React.createElement(MobileBreadcrumb, { previousBreadcrumb: previousBreadcrumb, currentBreadcrumb: currentBreadcrumb })))) : (React.createElement("ol", { className: pageHeaderStyles.breadcrumbsList }, breadcrumbs.map(function (breadcrumb, index) {
                var _a;
                var isCurrentBreadcrumb = index + 1 === breadcrumbs.length;
                return (React.createElement("li", { className: classNames(pageHeaderStyles.breadcrumbsListItem, (_a = {}, _a[pageHeaderStyles.isLast] = index !== 0 && isCurrentBreadcrumb, _a)), key: breadcrumb.name }, !isCurrentBreadcrumb ? React.createElement(NavLink, { to: breadcrumb.url }, breadcrumb.name) : React.createElement("span", null, breadcrumb.name)));
            }))))),
            (!hideContentOnMobile || !isMobile) && (React.createElement(React.Fragment, null,
                !!title && (React.createElement("h1", { className: classNames('heading1', pageHeaderStyles.title) },
                    title,
                    !!onClickHelpIcon && (React.createElement(IconButton, { iconType: "fill", onClick: onClickHelpIcon },
                        React.createElement(HelpIcon, null))))),
                !!subtitle && React.createElement("h6", { className: classNames('subtitle', pageHeaderStyles.subtitle) }, subtitle),
                !!children && React.createElement("div", { className: pageHeaderStyles.children }, children))))));
}
export default PageHeader;
